import $ from 'jquery';

function IsTouch() {
    return $('html.touch').length > 0; // Skip jQuery and return window.Feature.detected.touch?
}

export default IsTouch;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/is-touch.js